const theme = {
  layout: {
    container: 'mx-auto w-full max-w-6xl px-4 sm:px-6 md:px-8',
    page: 'mx-auto w-full max-w-6xl px-4 sm:px-6 md:px-8 flex-grow',
  },
  link: 'text-blue-800 hover:text-blue-900 hover:underline',
  text: {
    body: 'text-gray-700',
    muted: 'text-gray-600',
    subtle: 'text-gray-400',
    heading: 'text-gray-900',
    strong: 'text-gray-950',
    sectionTitle: 'text-2xl font-semibold tracking-tight text-gray-900',
    pageTitle: 'text-3xl font-semibold tracking-tight text-gray-900',
    eyebrow: 'text-xs font-semibold uppercase tracking-[0.18em] text-gray-400',
  },
};

export default theme;
